export default __webpack_public_path__ + "bb8d6d1f9ef7b3aad9cc15c0f717f3c5.png";